module.exports = __webpack_public_path__ + "static/img/1370_phase_function_Paper_PointsHejduk_Prediction.cfdbab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1370_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 2pam
// module chunks = 0